import axios from "axios";
import router from "../../router";

//Está ação registra o login do usuário
const actionSetUser = async ({commit}, payload) => {
  let formData = new FormData();
  formData.append('username', payload.username);
  formData.append('password', payload.password);
  formData.append('partner', 'rr.scl');
  try {
    const user = await axios.post(`${process.env.VUE_APP_URL_API}/sign_in`, formData);
    if(user) {
      localStorage.setItem("user", JSON.stringify(user.data.data));
      commit("SET_LOGGED_USER", user.data.data);
      commit("SET_HEADERS", user.data.data.attributes);
      router.push({name:"Home"});
    }
  } catch(error) {
    console.log(error)
  }
}
//Está ação desloga e limpa o chace do localstorage do usuário
const actionLogout = ({commit}) => {
  localStorage.clear();
  commit("SET_LOGOUT");
  router.push({name:"Login"});
  document.location.reload(true);
}
//Está checka se há um usuário logado 
const actionCheckLogin = ({commit}) => {
  const user = localStorage.getItem("user");
  if(user) {
    commit("SET_LOGGED_USER", JSON.parse(user));
    commit("SET_HEADERS", JSON.parse(user).attributes);
    router.push({name:"Home"})
  } else {
    router.push({name:"Login"})
  }
}
export default {
  actionSetUser,
  actionLogout,
  actionCheckLogin
}